import { jsx as _jsx } from "react/jsx-runtime";
import CircularProgress from '@material-ui/core/CircularProgress';
var StationsIsFetching = function (_a) {
    var isFetching = _a.isFetching;
    if (!isFetching)
        return null;
    return _jsx(CircularProgress, { style: { color: "#A3A6B4" }, value: 75, disableShrink: true }, void 0);
};
export default StationsIsFetching;
//# sourceMappingURL=StationsIsFetching.js.map